import Vue from 'vue';
import Router from 'vue-router';

import ViewPage from '@/components/View/ViewPage';

import IndexPage from "./components/Index/IndexPage";
//import PrintPage from './components/Print/PrintPage';
import PreviewDocument from './components/PreviewDocument/PreviewDocument';
import verifyExternal from './components/verifyExternal/verifyExternal';

Vue.use(Router);


export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: { name: 'index' },
        },
        {
            path: '/list/:status?',
            name: 'index',
            component: IndexPage,
            meta: {
                breadcrumb: [
                    { name: 'mortgages.title' },
                ],
            },

        },
        {
            path: '/Print/:id',
            name: 'PrintSak',
            component: PreviewDocument, //PrintPage,
            meta: {
                breadcrumb: [
                    { name: 'mortgages.title', link: '/list' },
                    { name: 'معاينة الوثيقة' },
                ],
            },
        },
        {
            path: '/Verify/',
            name: 'Verify',
            component: verifyExternal,
               props: (route) =>
            ({
                       docNo: route.query.docNo,
                       docDate: route.query.docDate,
            }),
        },
        {
            path: '/view/:id',
            name: 'viewInternal',
            component: ViewPage,
            meta: {
                breadcrumb: [
                    { name: 'mortgages.title', link: '/list' },
                    { name: 'تفاصيل وثيقة اعتماد بيان رهن أعيان' },
                ],
            },
        },
        {
            path: '/view',
            name: 'viewExternal',
            component: ViewPage,
            props: (route) =>
            ({
                EId: route.query.id,
                EKey: route.query.key,
            }),
            meta: {
                breadcrumb: [
                    { name: 'mortgages.title', link: '/list' },
                    { name: 'تفاصيل وثيقة اعتماد بيان رهن أعيان' },
                ],
            },
        },
    ],
});

